import { Amount } from 'src_common/common/amount/Amount';

export type TransactionParamsType =
    | 'all'
    | 'deposit'
    | 'withdrawal'
    | 'bet'
    | 'net-deposit'
    | 'virtualsports-wager'
    | 'live-casino-wager;live-casino-generic'
    | 'casino-wager;casino-generic'
    | 'bingo-wager;bingo-wager-rollback;bingo-result';

export interface TransactionsForViewTypes {
    id: string;
    displayId: number;
    balanceDelta: string;
    balanceAfter: null | undefined | string;
    currency: string;
    date: string;
    status: string;
    type: string;
    cashout: null | undefined | boolean;
    displayedReason: string;
    fundsLocked: string;
    adjustmentType: string | null | undefined;
    hideAmount: boolean;
}
export type StatusType = 'loading' | 'error' | 'ready' | undefined;

export const isMoneySentTransaction = (type: string): boolean => type === 'money-sent';

export const isWithdrawalFundsLockedTransaction = (type: string): boolean => type === 'withdrawal-funds-locked';

const isZeroAmount = (balanceDelta: string, fundsLocked: string): boolean => {
    const amount = new Amount(balanceDelta).isEqualWith(new Amount('0'))
        ? new Amount(fundsLocked)
        : new Amount(balanceDelta);

    return amount.isEqualWith(new Amount('0'));
};

export const shouldHideTransactionHistoryRow = (type: string, status: string, fundsLocked: string): boolean => {
    if (isMoneySentTransaction(type) && status !== 'failed') {
        return true;
    }

    if (
        isWithdrawalFundsLockedTransaction(type) &&
        status === 'paid' &&
        new Amount(fundsLocked).isEqualWith(new Amount('0'))
    ) {
        return true;
    }

    return false;
};

export const shouldHideTransactionAmount = (
    type: string,
    status: string,
    balanceDelta: string,
    fundsLocked: string
): boolean => {
    if (isWithdrawalFundsLockedTransaction(type) && status !== 'paid') {
        return true;
    }

    if (isZeroAmount(balanceDelta, fundsLocked) === false) {
        return false;
    }

    if (isMoneySentTransaction(type) && status === 'failed') {
        return true;
    }

    if (type === 'withdrawal' && (status === 'pending' || status === 'failed' || status === 'cancelled')) {
        return true;
    }

    return false;
};
